import $ from "jquery";
import "@/scripts/helpers/polyfills";
import Offcanvas from "@/modules/layout/offcanvas/index";
import {
  attachIE11helper,
  attachEdgeBrowserHelper,
  attachSafariBrowser,
  initWowLibrary,
  initCustomSelectPlugin,
  initIntlTelInputPlugin,
  bindJQuery,
  handleParsleyActions
} from "@/scripts/helpers/library";

bindJQuery();

$(document).ready(function() {
  Offcanvas();
  handleParsleyActions();
  initWowLibrary();
  initCustomSelectPlugin();
  initIntlTelInputPlugin();
  attachIE11helper();
  attachSafariBrowser();
  attachEdgeBrowserHelper();
});


